import { memo, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import { usePersonInChargeUsers } from "@/api/services/main/user";
import { CollapsibleCard } from "@/components/elements/CollapsibleCard";
import { FormField } from "@/modules/irohana-components/elements/FormField";
import { Select } from "@/modules/irohana-components/elements/Select";
import { SELECT_PLACEHOLDER } from "@/features/organization/invoice/constants/invoiceEnums";
import { TInvoiceForm } from "@/features/organization/invoice/types/InvoiceForm";
import { TOption } from "@/types/common";

/** システム既定担当者 — fallback assignee for linked 取引先・受注. Options come from org users. */
export const DefaultAssigneeSection = memo(() => {
  const { control } = useFormContext<TInvoiceForm>();
  const { users } = usePersonInChargeUsers();

  const options: TOption[] = useMemo(() => users.map((user) => ({ value: String(user.id), label: user.fullName })), [users]);

  return (
    <CollapsibleCard title="システム既定担当者" description="連携作成された取引先・受注で担当者が特定できない場合の既定担当者を設定できます。">
      <FormField control={control} name="defaultAssignee" label="既定担当者" required>
        <Select options={options} placeholder={SELECT_PLACEHOLDER} clearable />
      </FormField>
    </CollapsibleCard>
  );
});

DefaultAssigneeSection.displayName = "DefaultAssigneeSection";
